import ConfigurazioniPage from "./pages/ConfigurazioniPage.vue";

export default {
	ConfigurazioniPage,
};
